document.addEventListener("DOMContentLoaded", () => {
  var e = !0,
    t = !0;
  function o() {
    let o = document.querySelector(".sticky_container"),
      n = document.querySelector(
        ".product-builder-custom-content .text-under-slider",
      ),
      l = document.querySelectorAll(
        ".product-builder-custom-content .product__payment-item",
      ),
      r = document.querySelector("#tee-gallery"),
      i = document.querySelector(".product__info-wrapper");
    if (r) {
      if (o) {
        let e = o.outerHTML;
        r.insertAdjacentHTML("afterbegin", e);
      }
      if (n) {
        let e = r.querySelector(".tee-slide"),
          t = n.outerHTML;
        (r.querySelector(".tee-slider").insertAdjacentHTML("afterend", t),
          e && e.classList.add("transparent-bg"));
      }
      l.length > 0 &&
        l.forEach((e) => {
          let t = document.querySelector("#teeFormActions"),
            o = e.outerHTML;
          t && t.insertAdjacentHTML("beforeend", o);
        });
      const i = document.querySelector(".tee-gallery-content"),
        c = document.querySelector(".tee-gallery-content .icon.max_min_icon");
      (document
        .querySelector(".tee-gallery-content .icon.collaps_icon")
        ?.addEventListener("click", function (e) {
          return (
            e.preventDefault(),
            e.stopPropagation(),
            1 == t
              ? ((this.querySelector(".collapsable_icon").style =
                  "display: none"),
                (this.querySelector(".eye_icon").style = "display: block"),
                (i.querySelector(".tee-gallery").style =
                  "display: none !important;"),
                void (t = !1))
              : ((this.querySelector(".collapsable_icon").style =
                  "display: block"),
                (this.querySelector(".eye_icon").style = "display: none"),
                (i.querySelector(".tee-gallery").style =
                  "display: block !important"),
                void (t = !0))
          );
        }),
        c?.addEventListener("click", function (t) {
          return (
            t.preventDefault(),
            t.stopPropagation(),
            1 == e
              ? ((function () {
                  i.classList.add("resized");
                  for (let e = 1; e <= 35; e++)
                    setTimeout(() => {
                      ((i.style.width = 100 - e + "%"),
                        window.dispatchEvent(new Event("resize")));
                    }, 2 * e);
                })(),
                (e = !1),
                (this.querySelector(".min_icon").style = "display: none"),
                void (this.querySelector(".max_icon").style = "display: block"))
              : ((function () {
                  i.classList.add("resized");
                  for (let e = 1; e <= 35; e++)
                    setTimeout(() => {
                      ((i.style.width = `${65 + e}%`),
                        window.dispatchEvent(new Event("resize")));
                    }, 2 * e);
                })(),
                (e = !0),
                (this.querySelector(".min_icon").style = "display: block"),
                void (this.querySelector(".max_icon").style = "display: none"))
          );
        }));
    }
    if (i && n) {
      let e = n.outerHTML;
      i.insertAdjacentHTML("afterbegin", e);
    }
  }
  !(function () {
    document.querySelector("#tee-gallery");
    let n = setInterval(() => {
      (function () {
        let e;
        return (
          (this.slider = document.querySelector("#tee-gallery")),
          (e = !!this.slider),
          e
        );
      })() &&
        (o(),
        (function () {
          new URLSearchParams(window.location.search);
          const r = document.querySelector("#teeAtcButton");
          console.log(r, "=>teeAtcButton");
          
        })(),
        (function () {
          const e = document.getElementById("teeFormInputs"),
            t = { attributes: !0, childList: !0, subtree: !0 },
            o = new MutationObserver(function () {
              (o.disconnect(), o.observe(e, t));
            });
          o.observe(e, t);
        })(),
        clearInterval(n));
    }, 500);
  })();
});
